// REACT IMPORTS
import React, { useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../context/Data";
import LazyLoad from 'react-lazyload';

// COMPONENT IMPORTS
import BackToTop from "../BackToTop";

// MUI IMPORTS
import { Card, Typography, Box, Tooltip } from "@mui/material"; 
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "@fontsource/roboto-mono"; // Import the font
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import useMediaQuery from "@mui/material/useMediaQuery";
// import { FaGithub, FaYoutube } from "react-icons/fa";

function HandleProjects() {
  const [showDetailedOverview, setShowDetailedOverview] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const { id } = useParams();
  const { projects } = useContext(DataContext);

  const theme = createTheme({
    typography: {
      fontFamily: "Roboto Mono, monospace",
    },
  });

  const styles = {
    backgroundColor: "black",
    color: "white",
    minHeight: "100vh",
    padding: "20px",
  };

  const smallCardStyles = {
    width: {xs: "100%", lg: "45%"}, 
    display: "flex", 
    flexDirection: "row", 
    alignItems: "center", 
    justifyContent: "center",
    margin: "0 auto",
    gap: 2,
    pt: 1,
    pb: 1
  }

  const currentProject = projects?.find(
    (project) => project?.id === parseInt(id)
  );


  return (
    <ThemeProvider theme={theme}>
      <Box style={styles}>
        <Button style={{ color: "white" }} onClick={() => navigate("/")}>
          <ArrowBackIosIcon />
        </Button>
        <Typography variant="h4" sx={{mt: 5,}}>{currentProject?.title}</Typography>
        <hr style={{ width: "50%" }} />

        <Typography variant="body2" sx={{ mt: 5, pb: 1}}>
          Description
        </Typography>
        <Card sx={{...smallCardStyles, mb: 5 }}>
          <Typography variant="body1">{currentProject?.description}</Typography>
        </Card>
        {/* <hr style={{ width: "50%", marginTop: "40px" }} /> */}

        {currentProject?.detailedOverview !== null ? (
          <>
            <Button
              style={{ marginTop: "40px", color: "white" }}
              onClick={() => setShowDetailedOverview(!showDetailedOverview)}
            >
              {showDetailedOverview
                ? "Hide Detailed Overview"
                : "Show Detailed Overview "}
            </Button>
            {showDetailedOverview && (
              <Card
                style={{
                  width: isMobile ? "100%" : "45%",
                  height: "130%",
                  margin: "0 auto",
                  marginTop: "20px",
                }}
              >
                <Typography variant="body1">
                  {currentProject?.detailedOverview}
                </Typography>
              </Card>
            )}
          </>
        ) : null}


        <Typography variant="body2" sx={{pb: 1 }}>
          Technologies Used
        </Typography>

        <Card sx={{...smallCardStyles, mb: 5}}>
          {currentProject?.languages?.map((lang, index) => (
            <Box key={index}>{lang}</Box>
          ))}
        </Card>

        <Typography variant="body2" sx={{ pb: 1 }}>
          Links
        </Typography>
        <Card sx={{...smallCardStyles}}>
          {currentProject?.links?.map((link, index) => (
            <Box 
            component="a"
            key={index}
            href={link?.url ? link?.url : null} 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ color: "inherit", textDecoration: "none" }}
            >
              <Tooltip title={link?.tooltipText}>
                <span>
                  {link?.icon}
                </span>
              </Tooltip>
            </Box>
          ))}
        </Card>

        <hr style={{ width: "50%", marginTop: "40px" }} />

        <Typography variant="h5" sx={{ mt: 5 }}>
          Photos
        </Typography>

         {currentProject?.images?.map((image) => (
            <Card
              key={image?.url}
              sx={{
                width: isMobile ? "100%" : "45%",
                height: isMobile ? "auto" : "130%",
                mx: "auto",
                mt: 3,
                overflow: "hidden",
                position: "relative",
                backgroundColor:
                  currentProject?.title === "Not Airbnb" ||
                  currentProject?.title === "Smart Inventory"
                    ? "white"
                    : "black",
                border: "1px solid white",
              }}
            >
              <LazyLoad height={isMobile ? 200 : 400} offset={100} placeholder={<img src={image?.url?.lowResUrl} alt="Loading..." width="100%" height={isMobile ? "auto" : "50vh"} />}>
              <img
                src={image?.url}
                style={{
                  height: isMobile ? "auto" : "50vh",
                  width: isMobile ? "100%" : "100%",
                  objectFit: "contain",
                  backgroundColor:
                    currentProject?.title === "Not Airbnb" ||
                    currentProject?.title === "Smart Inventory"
                      ? "white"
                      : "black",
                }}
                alt={image?.description}
              />
              </LazyLoad>
              <Typography
                sx={{
                  backgroundColor:
                    currentProject?.title === "Not Airbnb" ||
                    currentProject?.title === "Smart Inventory"
                      ? "white"
                      : "black",
                  color:
                    currentProject?.title === "Not Airbnb" ||
                    currentProject?.title === "Smart Inventory"
                      ? "black"
                      : "white",
                  position: "absolute",
                  bottom: "2px",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                {image?.description}
              </Typography>
            </Card>
          ))
        }
        <BackToTop />
      </Box>
    </ThemeProvider>
  );
}

export default HandleProjects;
